import * as React from "react";

const AscendingIcon = () => (
      <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="none"
            viewBox="0 0 16 16"
      >
            <path
                  fill="#CFD7E8"
                  d="M8.667 12.528V5.08l3.253 3.253c.26.26.687.26.947 0s.26-.68 0-.94L8.473 3.001a.664.664 0 0 0-.94 0l-4.4 4.387a.664.664 0 1 0 .94.94l3.26-3.247v7.447c0 .366.3.666.667.666s.667-.3.667-.666"
            ></path>
      </svg>
);

export default AscendingIcon;
